const STORAGE_KEY = "amber_click_counts";

interface ClickCounts {
  [key: string]: number;
}

/**
 * Get all stored click counts from localStorage.
 */
const getClickCounts = (): ClickCounts => {
  try {
    if (typeof window === "undefined") return {};
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};

/**
 * Increment click count for a specific user + entity combination.
 * Returns the new count after incrementing.
 *
 * Key format: `${email}__${entityType}__${entityId}`
 */
export const incrementClickCount = (
  email: string,
  entityType: "property" | "tenancy" | "enquire",
  entityId: string,
): number => {
  const counts = getClickCounts();
  const key = `${email}__${entityType}__${entityId}`;
  counts[key] = (counts[key] || 0) + 1;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(counts));
  } catch {
    // localStorage full or unavailable — silently fail
  }
  return counts[key];
};

/**
 * Get click count for a specific user + entity combination.
 */
export const getClickCount = (
  email: string,
  entityType: "property" | "tenancy" | "enquire",
  entityId: string,
): number => {
  const counts = getClickCounts();
  const key = `${email}__${entityType}__${entityId}`;
  return counts[key] || 0;
};
